"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Tick = (0, _createIcon["default"])({
  path: 'M6.509 12.086L2.578 9.304a1 1 0 0 0-1.156 1.633l4.777 3.38a1 1 0 0 0 1.413-.268l7.224-11a1 1 0 0 0-1.672-1.098L6.51 12.086z',
  viewBox: '16 16',
  icon: 'tick',
  displayName: 'Tick'
});
var _default = exports["default"] = Tick;